import React from 'react';
import ShiftRow from './ShiftRow/ShiftRow';

const UnassignedShifts = ({
  shifts,
  daysOfWeek,
  onShiftClick,
  selectedDate,
  selectedShift,
  onAddShift,
  dateFromShiftButton,
  onDateFromShiftButtonChange,
}) => {
  return (
    <ShiftRow
      role="Unassigned"
      assigned={false}
      name="Unassigned"
      shifts={shifts}
      daysOfWeek={daysOfWeek}
      onShiftClick={onShiftClick}
      selectedDate={selectedDate}
      selectedShift={selectedShift}
      onAddShift={onAddShift}
      dateFromShiftButton={dateFromShiftButton}
      onDateFromShiftButtonChange={onDateFromShiftButtonChange}
    />
  );
};

export default UnassignedShifts;
